import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GlobalService } from '../../global.service';
import { HttpService } from '../../http.service';
import { WardService } from '../../ward/ward.service';

@Component({
  selector: 'app-ward-register',
  templateUrl: './ward-register.component.html',
  styleUrls: ['./ward-register.component.scss']
})
export class WardRegisterComponent {
  ward_register_form: FormGroup;
  constituencies: any[] = [];
  action: 'register' | 'update' = null;
  corp_zones: any[] = []
  constructor(private formBuilder: FormBuilder, private global: GlobalService, private http: HttpService, private wardService: WardService) {
    this.ward_register_form = formBuilder.group({
      constituency_id: [null, Validators.compose([Validators.required])],
      ward_id: [null, Validators.compose([])],
      name: [null, Validators.compose([Validators.required])],
      ward_number: [null, Validators.compose([Validators.required])],
      corporation_zone: [null, Validators.compose([Validators.required])],
    });
    this.getConstituency();
    this.getCorporation();
    // one time data get
    if (this.wardService.get_ward_data === null) {
      this.action = 'register';
    } else {
      this.action = 'update';
      this.setupUpdateForm(this.wardService.get_ward_data);
    }

    // watch table add or edit button clicked
    this.wardService.wardUpdate.subscribe((ward) => {
      if (ward === null) {
        this.action = 'register';
        this.ward_register_form.reset();
      } else {
        this.action = 'update';
        this.setupUpdateForm(ward);
      }
    });
  }

  getCorporation() {
    this.http.getCorporationZone().subscribe((data: any[]) => {
      console.log(data);
      this.corp_zones = data;
    }, (error) => {
      console.log(error);
    });
  }

  getConstituency() {
    this.http.getConstituency().subscribe((data: any[]) => {
      console.log(data);
      this.constituencies = data;
    }, (error) => {
      console.log(error);
    });
  }

  registerWard() {
    this.http.registerWard(this.ward_register_form.value).subscribe((data) => {
      console.log(data);
      this.ward_register_form.reset();
      this.global.showSnakeBar(data['message']);
      this.wardService.downloadWard.emit(true);
    }, (error) => {
      console.log(error);
    });
  }

  setupUpdateForm(ward) {
    this.ward_register_form.controls['constituency_id'].setValue(ward['constituency_id']);
    this.ward_register_form.controls['ward_id'].setValue(ward['id']);
    this.ward_register_form.controls['name'].setValue(ward['name']);
    this.ward_register_form.controls['ward_number'].setValue(ward['ward_number']);
    this.ward_register_form.controls['corporation_zone'].setValue(ward['corporation_zone']);
    
    
  }
}
